@if (portalBadgeConfig(); as badgeConfig) {
  <ftr-badge [icon]="badgeConfig.icon" [color]="badgeConfig.badgeColor" displayType="tile" />
}
